import { UnsubscribeQueryRequiredParamsName } from '../types';

export const isUnsubscribeQuery = (query: string) => {
  const queryParams = new URLSearchParams(query);
  const queryNames = Object.values(UnsubscribeQueryRequiredParamsName);

  return queryNames.every(name => queryParams.has(name));
};
